import Axios from 'axios';

const RESOURCE_CP_DEALER = '/items/'
const RESOURCE_LOCAL_DEALER = '/ControlPanel/migration/status/'


export class Payload {
    constructor(endpoint, method, payload) {
        this.endpoint = endpoint
        this.method = method, // GET, POST, PUT, DELETE
        this.payload = payload || {}
        this.headers = []
    }
    withCredentials(key, value) {
        this.headers.push({ key, value })
    }
}

export const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};

export default {
    cpApi: {
        async setDealerService(sellerIdentifier, serviceIdentifier, removeService) {


            const options = removeService ?
                new Payload(`${process.env.VUE_APP_CP_ENDPOINT}${RESOURCE_CP_DEALER}${sellerIdentifier}/services/${serviceIdentifier}`, 'DELETE') :
                new Payload(`${process.env.VUE_APP_CP_ENDPOINT}${RESOURCE_CP_DEALER}${sellerIdentifier}/services`, 'POST', {
                    identifier: serviceIdentifier,
                    status: "active"
                });

            options.withCredentials('x-user-identifier', sellerIdentifier);

            try {
                const response = await apiProxy(options);
                const data = await response.data;
                return data;

            } catch (error) {
                throw new Error(error);
            }

        },
        async getDealerServices(sellerIdentifier) {

            const options = new Payload(`${process.env.VUE_APP_CP_ENDPOINT}${RESOURCE_CP_DEALER}${sellerIdentifier}/services`, 'GET');

            try {
                const response = await apiProxy(options);
                const data = await response.data;
                return data;

            } catch (error) {
                throw new Error(error);
            }
        }
    },
    localApi: {
        async getDealerService(sellerIdentifier) {

            try {
                const response = await Axios.get(`${RESOURCE_LOCAL_DEALER}${sellerIdentifier}`);
                const data = await response.data;
                return data;
            } catch (error) {
                throw error;
            }
        },
        async setDealerService(sellerIdentifier, { email }) {

            try {
                const response = await Axios.post(`${RESOURCE_LOCAL_DEALER}${sellerIdentifier}`, { user: email})
                const data = await response.data;
                return data;
            } catch (error) {
                throw error;
            }
        }

    }
};